"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _reactCsv = require("react-csv");

var _icons = require("@ant-design/icons");

// import { useHistory } from 'react-router';
var todayDate = new Date();
var year = todayDate.getFullYear();
var month = ("0" + (todayDate.getMonth() + 1)).slice(-2);
var day = ("0" + todayDate.getDate()).slice(-2);
var today = "".concat(year, "-").concat(month, "-").concat(day);
var time = "".concat(todayDate.getHours(), ":").concat(todayDate.getMinutes());

var TableData = function TableData(_ref) {
  var data = _ref.data;
  var header = [{
    label: "Today Date",
    key: "sendDate"
  }, {
    label: "CR Code",
    key: "RM_code"
  }, {
    label: "CR Name",
    key: "RM_name"
  }, {
    label: "Total Student",
    key: today === data[0].sendDate ? "totalStudent" : "totalRes"
  }, {
    label: "Total Send Worksheet",
    key: "totalSendRes"
  }, {
    label: "Total Not Send Worksheet",
    key: "totalNotRes"
  }];
  var csvRport = {
    filename: "Math Morning Data " + today + " " + time,
    headers: header,
    data: data
  }; // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1]; // useEffect(async () => {
  //   setTableData(data);
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fatchData() {
      return _fatchData.apply(this, arguments);
    }

    function _fatchData() {
      _fatchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fatchData.apply(this, arguments);
    }

    fatchData();
  }, [data]);
  var columns = [{
    title: "CR Code",
    dataIndex: "RM_code",
    key: "RM_code",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "CR Name",
    dataIndex: "RM_name",
    key: "RM_name",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_name');
    }
  }, {
    title: "Date",
    dataIndex: "sendDate",
    key: "sendDate",
    render: function render(_, record) {
      return record.sendDate ? record.sendDate : "No Data";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'sendDate');
    }
  }, {
    title: "Total Student",
    dataIndex: "totalRes",
    key: "totalRes",
    render: function render(_, record) {
      return record.sendDate === formatDate() ? record.totalStudent : record.totalRes;
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'totalRes');
    }
  }, {
    title: "बचे हुए सुबह के फॉर्म ",
    dataIndex: "totalNotRes",
    key: "totalNotRes",
    render: function render(_, record) {
      return record.sendDate === formatDate() ? record.totalStudent - record.totalSendRes : record.totalNotRes;
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'totalNotRes');
    }
  }];

  function formatDate() {
    var d = new Date();
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Math Morning Response",
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: tableData,
    rowKey: "index"
  })));
};

var _default = TableData;
exports.default = _default;